/**
 * Cognito group for Delete Casino Accounts.
 * Keep in sync with services/ms-auth and ms-casino userFlagHelper
 * DELETE_CASINO_ACCOUNTS_GROUP / canAccessDeleteCasinoAccounts.
 */
export const DELETE_CASINO_ACCOUNTS_GROUP = 'slotcheck-enterprise-deleteCasinoAccounts';

/** True when cognito:groups includes the Delete Casino Accounts enterprise group. */
export function canAccessDeleteCasinoAccounts(groups: string[] = []): boolean {
  return Array.isArray(groups) && groups.includes(DELETE_CASINO_ACCOUNTS_GROUP);
}

/** Step 1 confirm: re-typed email must match looked-up email (trim + case-insensitive). */
export function emailsMatchForDeleteConfirm(
  lookedUpEmail: string,
  retypedEmail: string
): boolean {
  const a = String(lookedUpEmail || '')
    .trim()
    .toLowerCase();
  const b = String(retypedEmail || '')
    .trim()
    .toLowerCase();
  return Boolean(a) && a === b;
}

/** Side menu item is shown only to delete-group members. */
export function shouldShowDeleteCasinoAccountsMenu(groups: string[] = []): boolean {
  return canAccessDeleteCasinoAccounts(groups);
}
